import { useEffect } from 'react';
import type { PropsElement } from '@/hero/data';
import type { Selection } from '@/state/selection';
import { useHeroStore } from '@/store/store';
import { runKey, useRulesStore } from './state';
import { resultsFor } from './verdicts';

// Which specifications of the current rule set apply to the element, and how it did.
export function RulesCard({
  element,
}: {
  selection: Selection;
  element: PropsElement | undefined;
}) {
  const report = useRulesStore((s) => s.report);
  const status = useRulesStore((s) => s.status);
  const ranFor = useRulesStore((s) => s.ranFor);
  const active = useRulesStore((s) => s.active);
  const version = useHeroStore((s) => s.version);
  const ready = useHeroStore((s) => s.status) === 'ready';
  const stale = ranFor !== runKey(active, version);

  // outside the rules station nothing else keeps the check current
  useEffect(() => {
    if (ready && stale) void useRulesStore.getState().run();
  }, [ready, stale]);

  const results = report && element?.globalId ? resultsFor(report, element.globalId) : [];
  return (
    <div className="card-rules">
      {results.length === 0 ? (
        <p className="ids-note">
          {status === 'checking'
            ? 'checking…'
            : report
              ? 'No specification of this rule set applies here.'
              : '–'}
        </p>
      ) : (
        <ul>
          {results.map((r) => (
            <li key={r.spec} data-verdict={r.verdict}>
              <span className="verdict">{r.verdict === 'pass' ? '✓' : '✗'}</span>
              <span>
                {r.spec}
                {r.requirements.map((q) => (
                  <small key={q}>{q}</small>
                ))}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
